import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { updateClientAdminDetails } from "../http/requests/client-admin";
import {
  ClientAdminType,
  getClientAdminData,
  getClientsData,
  setVtrackLoader,
} from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";

function* workerUpdateClientAdminSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    yield call(updateClientAdminDetails, payload.data);
    let page=payload.data.pageNo;page+=1;
    let rows=payload.data.rows;
    toast.success("Data Saved", toastOptions)
    payload.data.pageNo += 1
    yield put(
      getClientAdminData({
        pageNo: page,
        pageSize: rows,
        sortDir: "ASC",
        sortBy: "clientName",
        searchData: ''
      })
    );
    yield put(getClientsData());
    yield put(setVtrackLoader(false));
  } catch (err) {
    toast.error(err.data.errorMessage, toastOptions)
    yield put(setVtrackLoader(false));
  }
}

export function* updateClientAdminSaga() {
  yield takeLatest(
    ClientAdminType.UPDATE_CLIENT_ADMIN_DATA,
    workerUpdateClientAdminSaga
  );
}
